import { Component, OnInit, EventEmitter,Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { SessionService } from '../../../services/session.service';
import { PrecioAdicional } from '../../../models/precio_adicional';
import { TipoPrecioService } from '../../../services/tipo-precio.service';
import { TipoPrecio } from '../../../models/tipo_precio';
import { PrecioAdicionalService } from '../../../services/precio-adicional.service';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';

@Component({
  selector: 'app-editar-precio-modal',
  templateUrl: './editar-precio-modal.component.html',
  styleUrls: ['./editar-precio-modal.component.css'],
  providers: [
	SessionService,
	TipoPrecioService,
	PrecioAdicionalService
  ]
})
export class EditarPrecioModalComponent implements OnInit {
	@Input() precioAdd: PrecioAdicional;
	@Output() Respuesta: boolean;
	@Output() action = new EventEmitter();
	public loading: boolean;
	public tipos: Array<TipoPrecio>;
	public tipo: TipoPrecio;
	public msgSweet: SweetMessage;
	public Adicional: PrecioAdicional;
	public valor: number;
	public vl: Validation;

	constructor(
		public bsModalRef2: BsModalRef,
		public ss: SessionService,
		public tipoprecioService: TipoPrecioService,
		public pAdicionalService: PrecioAdicionalService,
	) { 
		this.loading = false;
		this.tipos = [];
		this.tipo = new TipoPrecio();
		this.msgSweet = new SweetMessage();
		this.Adicional = new PrecioAdicional();
		this.valor = 0;
		this.vl = new Validation();
	}

	ngOnInit() {
		this.valor = parseFloat(this.precioAdd.valor.toString());
		let p1 = this.getTipos();
        this.loading = true;

        Promise.all([p1]).then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

  	getTipos(){
		return new Promise((resolve, reject) => {
			this.tipoprecioService.getById(this.precioAdd.tipo_precio_id, "").subscribe(
				res => {
					this.tipo = res;
					resolve();
				},
				err => {
					reject(err);
				}
			);
		});
	}

	onSubmit(){
		this.setValores();
		this.loading = true;
		this.pAdicionalService.save(this.Adicional).subscribe(
			res => {
				this.loading = false;
				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
				this.Respuesta = true;
				this.action.emit(true);
				this.bsModalRef2.hide();
			},
			err => {
				this.loading = false;
                this.msgSweet.showMessage('error-message',err);
			}
		);
	}

	setValores(){
		this.Adicional = new PrecioAdicional();
		this.Adicional.producto_id = this.precioAdd.producto_id;
		this.Adicional.tipo_precio_id = this.precioAdd.tipo_precio_id;
		this.Adicional.usuario_id = this.ss.getData("usuario_id");
		this.Adicional.valor = this.valor;
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/editar-precio-modal/editar-precio-modal.component.ts